import { ApiPaths } from './ApiPaths';
import BaseApi from './BaseApi';

/**
 * API for managing workflow information
 * @param {String} baseURL
 */
const create = () => {  // this will change for prod deployment
    // Create and configure an apisauce-based api object.
    const api = BaseApi.create({
        timeout: 60000
    });

    const updateDocumentReviewTask = (ticketId, payload) => api.put(ApiPaths.DOCUMENT_REVIEW(ticketId), payload);
    const completeDocumentReviewTask = (ticketId, payload) => api.post(ApiPaths.DOCUMENT_REVIEW(ticketId), payload);
    const resetSignaturePage = (ticketId, workflowTaskId) => api.deleteRequest(ApiPaths.RESET_SIGNATURE_PAGE(ticketId, workflowTaskId));

    // Return back a collection of functions
    return {
        completeDocumentReviewTask, updateDocumentReviewTask, resetSignaturePage
    }
}

// let's return back our create method as the default.
export default {
    create
}
